"use client";

import { Kbd } from "@heroui/kbd";
import { BubbleChatAddIcon, PinIcon, SearchIcon } from "@icons";
import Link from "next/link";
import ModelSelectorDevControls from "@/components/layout/headers/ModelSelectorDevControls";
import { SidebarHeaderButton } from "@/components/layout/headers/SidebarHeaderButton";
import { prepareNewChat } from "@/features/chat/utils/newChatNavigation";
import { NotificationCenter } from "@/features/notification/components/NotificationCenter";
import { usePlatform } from "@/hooks/ui/usePlatform";

function preloadCommandMenu() {
  void import("@/features/search/components/CommandMenu");
}

export default function ChatHeader() {
  const { isMac, modifierKeyName } = usePlatform();

  // Command menu is now handled globally in the layout
  // Just trigger it to open via the global keyboard shortcut
  const handleSearchClick = () => {
    // Dispatch a keyboard event to trigger the command menu
    const event = new KeyboardEvent("keydown", {
      key: "k",
      metaKey: isMac,
      ctrlKey: !isMac,
      bubbles: true,
    });
    document.dispatchEvent(event);
  };

  return (
    <div className="flex w-full justify-between">
      <div className="relative ml-auto flex items-center">
        <ModelSelectorDevControls />
        <SidebarHeaderButton
          onClick={handleSearchClick}
          onMouseEnter={preloadCommandMenu}
          onFocus={preloadCommandMenu}
          aria-label="Search"
          tooltip={
            <div className="flex items-center gap-2">
              Search
              <Kbd keys={[modifierKeyName]}> K</Kbd>
            </div>
          }
        >
          <SearchIcon className="max-h-5 min-h-5 max-w-5 min-w-5 text-zinc-400 group-hover:text-primary" />
        </SidebarHeaderButton>
        <Link href={"/pins"}>
          <SidebarHeaderButton
            aria-label="Pinned Messages"
            tooltip="Pinned Messages"
          >
            <PinIcon className="min-h-[20px] min-w-[20px] text-zinc-400 transition-all group-hover:text-primary" />
          </SidebarHeaderButton>
        </Link>
        <Link href={"/c"} onClick={prepareNewChat}>
          <SidebarHeaderButton
            aria-label="Create new chat"
            tooltip="Create new chat"
          >
            <BubbleChatAddIcon className="min-h-[20px] min-w-[20px] text-zinc-400 transition-all group-hover:text-primary" />
          </SidebarHeaderButton>
        </Link>
        <NotificationCenter />
      </div>
    </div>
  );
}
